import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Box, CircularProgress, Typography } from '@mui/material';
import toast from 'react-hot-toast';
import jwtDecode from 'jwt-decode';

import { authApi } from 'src/api/authApi';
import { reportsApi } from 'src/api/reportsApi';
import { setJWT } from 'src/store/slices/jwtTokenSlice';
import { PATHS } from 'src/constants/config';

const ExpertAuth = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const handleExpertAuth = async () => {
      try {
        const response = await authApi.expertLogin(token);

        console.log(response);

        if (!response.data) {
          toast.error('Authentication failed');
          navigate(PATHS.AUTH.LOGIN.value);
        } else if (response.data.error) {
          toast.error(response.data.error);
          navigate(PATHS.AUTH.LOGIN.value);
        } else if (response.status === 'JWT returned') {
          const jwt = response.data;
          dispatch(setJWT({ token: jwt }));
          localStorage.setItem('jwtToken', jwt);
          toast.success('Login successful');
          const decodedJWT = jwtDecode(jwt);

          if (decodedJWT.queryID) {
            navigate(PATHS.QUERY_PROFILE.value.replace(':queryID', decodedJWT.queryID));
          } else if (decodedJWT.reportID) {
            const report = await reportsApi.fetchByID(Number(decodedJWT.reportID));

            const companySlug = report.company
              .replace(/([a-z])([A-Z])/g, '$1-$2')
              .toLowerCase()
              .replace(/\s+/g, '-');
            const startDate = report.startDate.split(' ')[0];
            const endDate = report.endDate.split(' ')[0];

            navigate(PATHS.REPORTS.PROFILE.value.replace(':companyID', companySlug) + `?startDate=${startDate}&endDate=${endDate}`);
          } else {
            navigate(PATHS.PITCH_INBOX.value);
          }
        }
      } catch (error) {
        toast.error(error.message);
        navigate(PATHS.AUTH.LOGIN.value);
      }
    };

    handleExpertAuth();
  }, [token, navigate, dispatch]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: 2,
      }}
    >
      <CircularProgress />
      <Typography variant="body1">Authenticating...</Typography>
    </Box>
  );
};

export default ExpertAuth;
